const INVOICE_FEATURE = "invoice";

export default [
  {
    path: "/:tenant/invoice",
    name: "invoice-list",
    component: () =>
      import(
        /* webpackChunkName: "inspection" */ "../views/invoice/InvoiceListView.vue"
      ),
    meta: {
      tenant: true,
      menu: true,
      feature: INVOICE_FEATURE,
      icon: "mdi-invoice-clock-outline",
      title: "crm.invoice.queue.title",
    },
  },
  {
    path: "/:tenant/invoice/:id",
    name: "invoice-view",
    component: () =>
      import(
        /* webpackChunkName: "inspection" */ "../views/invoice/InvoiceDetailsView.vue"
      ),
    props: true,
    meta: {
      tenant: true,
      menu: false,
      feature: INVOICE_FEATURE,
      icon: "mdi-invoice-clock-outline",
      title: "crm.invoice.queue.title",
    },
  },
];
